<dashboardnav>
    <cradua-bank
    [banks]="banks$ | async"
    (bank)="onSubmitBank($event)"
    (deleteBankEvent)="onDeleteBank($event)"
    *ngIf="(isLoadingBank$ | async ) === false"
    >
  </cradua-bank>

    <mrsoftapps-epims-reference-spinner
    *ngIf="(isLoadingBank$ | async) === true"
  >
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
  </dashboardnav>
